module.exports = __webpack_public_path__ + "img/phone.6f110433.svg";